<template>
    <div class="template-details-dialog">
        <el-dialog title="自定义" :visible.sync="showTemplateDialog" width="420px" :close-on-click-modal="false" :before-close="customClose">
            <el-form ref="customForm" :rules="customRules" :model="customForm" label-width="125px" @submit.native.prevent>
                <el-form-item label="自定义字段名" prop="field">
                    <el-input class="item-input" @keydown.native="fieIdDown" v-model.trim="customForm.field" maxlength="10"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="customClose">取 消</el-button>
                <el-button type="primary" @click="customDetermine">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: {
        showTemplateDialog: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        formFoot: {
            type: Object,
            default: function () {
                return {};
            }
        },
        tabRow: {
            type: Object,
            default: function () {
                return {};
            }
        },
        fieldNameOptions: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            customForm: {
                field: ''
            },
            customRules: {
                field: [
                    {
                        required: true,
                        message: '请输入自定义字段',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    methods: {
        customClose() {
            this.$emit('dialogDetermine', '');
            this.$emit('update:showTemplateDialog', false);
        },
        getFixed(val) { this.customForm.field = val; },
        customDetermine() {
            this.$refs['customForm'].validate(async (valid) => {
                if (valid) {
                    const repeatField = this.fieldNameOptions.find((item) => { return this.customForm.field === item.label; });
                    const customName = this.formFoot.tableData.filter((item) => { return item.fieldName === this.customForm.field; });
                    if (customName.length > 0) {
                        this.$message.warning('字段名称不能重复');
                        return;
                    }
                    if (repeatField) {
                        this.$message.warning('自定义字段不能和固定义字段相同！');
                        return;
                    }
                    const tabIndex = this.formFoot.tableData.indexOf(this.tabRow);
                    this.formFoot.tableData[tabIndex].fieldName = this.customForm.field;
                    this.$emit('dialogDetermine', this.customForm.field);
                    this.$emit('update:showTemplateDialog', false);
                }
            });
        },
        fieIdDown(e) {
            if (e.keyCode === '13' * 1) {
                this.customDetermine();
            }
        }
    }
};
</script>
<style lang="less">
.template-details-dialog {
}
</style>